export default "__VITE_ASSET__Do5m7lbB__"